/*
 * @Author: dali
 * @Date: 2022-08-29 09:53:21
 * @LastEditors: 陈威达 aser0827@163.com
 * @LastEditTime: 2025-04-22 13:53:05
 * @FilePath: \gerlun-react-website\src\pages\footer\index.jsx
 * @Description:
 */
import React, { useState, useEffect } from 'react'
import styles from './footer.scss'
import { useNavigate } from 'react-router-dom'
import { PhoneFilled } from '@ant-design/icons'
import User from '@/modules/user'

const Footer = () => {
  const navigate = useNavigate()
  const user = new User()
  const [tableData, setData] = useState([])
  const form = {
    pageSize: 6,
    pageNum: 1,
    articleName: '',
    releaseColumn: '产品中心',
    releaseColumnId: ''
  }
  const getData = () => {
    user.getArticleList(form)
      .then(res => {
        setData(res.result)
        console.log(res, '产品中心')
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  const handleNavigate = (path) => {
    handleIsSmall(false)
    handleIsSmall_two(false)
    handleIsSmall_three(false)
    handleIsSmall_four(false)
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }
  useEffect(()=>{
    getData()
  }, [])
  const [isSmall, handleIsSmall] = useState(false)
  const [isSmall_two, handleIsSmall_two] = useState(false)
  const [isSmall_three, handleIsSmall_three] = useState(false)
  const [isSmall_four, handleIsSmall_four] = useState(false)
  return (
    <div>
      <div className={styles['page_home_footer']}>
        <div className={`${styles.page_home_content} ${styles.w1250}`}>
          <dl>
            <dt>产品中心</dt>
            {
              tableData.map(val => {
                return (
                  <dd onClick={() => handleNavigate('/standard/' + val.id)} key={val.id}>
                    <a href='/#' onClick={(e) => e.preventDefault()}>{val.articleName}</a>
                  </dd>
                )
              })
            }
          </dl>
          <dl>
            <dt>市场活动</dt>
            <dd onClick={() => handleNavigate('/video-center')}><a href='/#' onClick={(e) => e.preventDefault()}>产品视讯</a></dd>
            <dd><a href='/#' onClick={(e) => e.preventDefault()}>产品功能</a></dd>
            <dd><a href='/#' onClick={(e) => e.preventDefault()}>会计学堂</a></dd>
            <dd><a href='/#' onClick={(e) => e.preventDefault()}>生态伙伴</a></dd>
          </dl>
          <dl>
            <dt>关于我们</dt>
            <dd onClick={() => handleNavigate('/aboutus')}><a href='/#' onClick={(e) => e.preventDefault()}>关于我们</a></dd>
            <dd onClick={() => handleNavigate('/aboutus')}><a href='/#' onClick={(e) => e.preventDefault()}>联系我们</a></dd>
          </dl>
          <dl className={styles['page-home-mr0']}>
            <dt>友情链接</dt>
            <dd><a href='http://www.chinatax.gov.cn/' target='_blank'>国家税务总局</a></dd>
            <dd><a href='http://www.mof.gov.cn/' target='_blank'>中国财政部</a></dd>
          </dl>
          <div className={styles['page-home-code']}>
            {/* <p><EnvironmentFilled style={{ fontSize: '16px' }} /> 宁波市镇海区创E慧谷4号概而论楼</p> */}
            <p className={styles['page-home-site']} style={{ fontSize: '16px' }}>
              杭州
              <span>·</span>
              上海
              <span>·</span>
              成都
              <span>·</span>
              武汉
              <span>·</span>
              长沙
              <span>·</span>
              合肥
              <span>·</span>
              宁波</p>
            <p><PhoneFilled style={{ fontSize: '16px' }} className={styles['page-home-filled']} /> 0574-8626 1037</p>
          </div>
        </div>
        <div className={`${styles.page_home_about} ${styles.w1250}`}>
          <p className={styles['character-title']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>关于我们</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>联系我们</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>加入我们</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>公司荣誉</a>
          </p>
          <p className={styles['character-title']}>
            <a href='/#' onClick={(e) => e.preventDefault()}>合作伙伴</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>下载中心</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>支持中心</a><span></span>
            <a href='/#' onClick={(e) => e.preventDefault()}>在线咨询</a>
          </p>
        </div>
      </div>
      <div className={styles['page_home_footer_x']}>
        <ul>
          <li onClick={() => handleIsSmall(!isSmall)}>
            <div>产品中心{ isSmall ? <span style={{ transition: 'all .2s linear', transform: 'rotate(-135deg)' }}>+</span > : <span style={{ transition: 'all .2s linear' }}>+</span> }</div>
            {isSmall && <ul>
              {
                tableData.map(val => {
                  return (
                    <li onClick={() => handleNavigate('/standard/' + val.id)}><a href='/#' onClick={(e) => e.preventDefault()}>{val.articleName}</a></li>
                  )
                })
              }
            </ul>}
          </li>
          <li onClick={() => handleIsSmall_two(!isSmall_two)}>
            <div>市场活动{ isSmall_two ? <span style={{ transition: 'all .2s linear', transform: 'rotate(-135deg)' }}>+</span > : <span style={{ transition: 'all .2s linear' }}>+</span> }</div>
            {isSmall_two && <ul>
              <li onClick={() => handleNavigate('/video-center')}><a href='/#' onClick={(e) => e.preventDefault()}>产品视讯</a></li>
              <li><a href='/#' onClick={(e) => e.preventDefault()}>产品功能</a></li>
              <li><a href='/#' onClick={(e) => e.preventDefault()}>会计学堂</a></li>
              <li><a href='/#' onClick={(e) => e.preventDefault()}>生态伙伴</a></li>
            </ul>}
          </li>
          <li onClick={() => handleIsSmall_three(!isSmall_three)}>
            <div>关于我们{ isSmall_three ? <span style={{ transition: 'all .2s linear', transform: 'rotate(-135deg)' }}>+</span > : <span style={{ transition: 'all .2s linear' }}>+</span> }</div>
            {isSmall_three && <ul>
              <li onClick={() => handleNavigate('/aboutus')}><a href='/#' onClick={(e) => e.preventDefault()}>关于我们</a></li>
              <li onClick={() => handleNavigate('/aboutus')}><a href='/#' onClick={(e) => e.preventDefault()}>联系我们</a></li>
            </ul>}
          </li>
          <li onClick={() => handleIsSmall_four(!isSmall_four)}>
            <div>友情链接{ isSmall_four ? <span style={{ transition: 'all .2s linear', transform: 'rotate(-135deg)' }}>+</span > : <span style={{ transition: 'all .2s linear' }}>+</span> }</div>
            {isSmall_four && <ul>
              <li><a href='http://www.chinatax.gov.cn/' target='_blank'>国家税务总局</a></li>
              <li><a href='http://www.mof.gov.cn/' target='_blank'>中国财政部</a></li>
            </ul>}
          </li>
        </ul>
        <div className={styles['page_home_codes']}>
          {/* <p><EnvironmentFilled style={{ fontSize: '12px' }} /> 宁波市镇海区创E慧谷4号概而论楼</p> */}
          <p><PhoneFilled style={{ fontSize: '12px' }} className={styles['page-home-filled']} /> 0574-8626 1037</p>
        </div>
      </div>
      <div className={styles['page-home-fuid']}>
        <p>© 2019-{new Date().getFullYear()} All Rights Reserved by Gerlun</p>
        <p>ICP：<a href='http://beian.miit.gov.cn/' target='_blank'>浙ICP备19023373号-1</a></p>
      </div>
    </div>
  )
}

export default Footer
